'use client';

import styles from '../styles/modals.module.css';
import { useState } from 'react';

export default function UploadIntroVidModal({
  isOpen,
  onClose,
  onSave
}) {

    // video and url states
    const [video, setVideo] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [uploading, setUploading] = useState(false);

    // reset everything if exited prematurely
    const close = () => {
      setPreviewUrl(null);
      setVideo(null);
      setUploading(false);
      onClose();}

    const handleVideoChange = (e) => {
        const vid = e.target.files[0];
    
        if (!vid) {
          setVideo(null);
          setPreviewUrl(null);
          return;
        }

        const maxSize = 25 * 1024 * 1024 * 1024; // 25 gigabytes
        if (vid.size > maxSize) {
          console.error('Video size must be less than 25GB');
          setVideo(null);
          setPreviewUrl(null);
          return;
        }
    
        setVideo(vid);
        setPreviewUrl(URL.createObjectURL(vid));
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!video) {
          console.error("Please send a video")
          return;
        }
    
        setUploading(true);
        
        try {
          // Get signed URL for upload
          const response = await fetch('/api/demanding-upload', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ filename: video.name, bucket: 'teacher-profile-videos' }),
          });

          const { uploadUrl, fileName } = await response.json();
          if (!response.ok) {
            throw new Error('Failed to get signed URL');
          }
          console.log(uploadUrl)
          // Upload directly to Supabase
          const uploadResponse = await fetch(uploadUrl, {
            method: 'PUT',
            body: video,
            headers: { 'Content-Type': video.type },
          });

          if (!uploadResponse.ok) {
            throw new Error('Failed to upload video to Supabase');
          }

          // Get public or signed URL for the video
          const urlResponse = await fetch('/api/demanding-upload/get-url', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ fileName, bucket: 'teacher-profile-videos' }),
          });

          const { imageUrl } = await urlResponse.json();
          if (!urlResponse.ok) {
            throw new Error('Failed to get video URL');
          }

          onSave(imageUrl);
          setVideo(null);
          setPreviewUrl(null);
        } catch (err) {
          console.error('Video upload error:', err);
        } finally {
          setUploading(false);
        }
      };

  if (!isOpen) return null;

  return (
    <div className={styles.modal} onClick={close}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <span className={styles.close} onClick={close}>&times;</span>
        <h2>Upload New Introduction Video:</h2>

        <form onSubmit={handleSubmit}>
          <div className={styles.formInput}>
            <label htmlFor="video" className={`${styles.btn} ${styles.btnPrimary}`}>
              {uploading ? 'Uploading...' : 'Upload'}
            </label>
            {previewUrl && <label htmlFor="video">
              {previewUrl}
            </label>}
            <input
              id="video"
              type="file"
              accept="video/*"
              onChange={handleVideoChange}
              disabled={uploading}
              className={styles.uploadInput}
            />
          </div>
          <button
            type="submit"
            disabled={uploading || !video}
            className={`${styles.btn} ${styles.btnPrimary}`}
          >
            {uploading ? 'Uploading...' : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  );
}